import React, { useState } from 'react'
import Layout from '../components/Layout'
import Business from '../components/Setting/BusinessConfiguration'
import { makeStyles, Grid, Tabs, Tab, Box } from '@material-ui/core'
import BusinessConfig1 from '../../src/components/Setting/BusinessConfig1'
import BusinessConfig2 from '../../src/components/Setting/BusinessConfig2'
import BusinessConfig3 from '../../src/components/Setting/BusinessConfig3'
import ProfilePic from '../../src/assets/images/Profile.PNG'
import ThreetabsLayout from '../components/ThreetabsLayout'
import ActionButton from '../components/ActionButton'
import ViewBusinessForm1 from '../components/version-4/viewForms/ViewBusinessForm1'
import ViewBusinessForm2 from '../components/version-4/viewForms/ViewBusinessForm2'
import ViewBusinessform3 from '../components/version-4/viewForms/ViewBusinessForm3'
import EditIcon from '@material-ui/icons/Edit'
import { ROUTES } from '../shared/constants'
import { useHistory } from 'react-router'
import { useCompanyConfig } from '../hooks/CompanyConfiguration/useCompanyConfig'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#EFF3FE',
    borderRadius: '10px',

    // margin: '10px 30px 10px 0px',
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Open sans',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  tabs: {
    '& > span': {
      maxWidth: '50px',
      width: '100%',
    },
    input: {
      '&:focus': {
        outline: 'none',
      },
    },
  },
}))

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

const ViewBusiness = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const { loggedUser, getLoggedInUser, updateCompanyConfig, updateCompanyPersonalInfo } = useCompanyConfig()

  const history = useHistory()
  const [basicInfoForm, setBasicInfoForm] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    phone: '',
    email: '',
    numberofemployees: '',
    domain: '',
    profilePicture: ProfilePic,
  })
  const { firstName, lastName, numberofemployees, domain, phone, email, profilePicture, companyName } = basicInfoForm

  const [accountSetting, setAccountSetting] = useState({
    language: null,
    currency: null,
    timeZone: null,
    financialYearStart: null,
    workingDays: null,
    reportingTime: null,
    releavingTime: null,
    holiday: null,
  })
  const [privacyDetails, setPrivacyDetails] = useState({
    question1: null,
    question2: null,
    question3: null,
    question4: null,
  })
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <Layout heading="Business Configuration">
      <Grid container className={classes.root}>
        <Grid
          item
          xs={12}
          lg={12}
          style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #CCCCCC' }}
        >
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabs}>
            <Tab
              label="Basic Information"
              {...a11yProps(0)}
              className={classes.tab}
              // disabled={value === 1 || value === 2 ? true : false}
            />
            <Tab
              label="Account Settings"
              {...a11yProps(1)}
              className={classes.tab}
              // disabled={!added || value === 2 ? true : false}
            />
            <Tab
              label="Privacy"
              {...a11yProps(2)}
              className={classes.tab}
              // disabled={!added && !addedLocation ? true : false}
            />
          </Tabs>
          <div
            style={{
              border: '1px solid #CCCCCC',
              borderRadius: '5px',
              margin: '5px',
              paddingTop: '3px',
              width: '30px',
              height: '30px',
              cursor: 'pointer',
            }}
          >
            <EditIcon onClick={() => history.push(ROUTES.BUSINESS)} />
          </div>
        </Grid>

        <TabPanel value={value} index={0}>
          <ViewBusinessForm1 />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <div style={{ width: '1024px' }}>
            <ViewBusinessForm2 />
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ViewBusinessform3 />
          {/* <EmployeeFormStep4 kycDetails={kycDetails} setKycDetails={setKycDetails} /> */}
        </TabPanel>
      </Grid>

      {/* <ThreetabsLayout
          tab1="Basic Information"
          tab2="Account Settings"
          tab3="Privacy"
          content1={<BusinessConfig1 form={basicInfoForm} setForm={setBasicInfoForm} />}
          content2={<BusinessConfig2 form={accountSetting} setForm={setAccountSetting} />}
          content3={<BusinessConfig3 form={privacyDetails} setForm={setPrivacyDetails} />}
          submit
        /> */}
    </Layout>
  )
}

export default ViewBusiness
